import React, { useEffect, useState } from "react";
import { getRouteStopListSearchApi } from "../../services/SearchService";
import Select from "react-select";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Icon } from "../../components";
import { Card, Row, Col, Form } from "react-bootstrap";
import Block from "../../components/Block/Block";
import { toast } from "react-toastify";
import { FaTrashCanArrowUp } from "react-icons/fa6";
import {
  getRouteStopSequenceApi,
  createRouteApi,
} from "../../services/TransportService";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { MdEdit, MdDelete } from "react-icons/md"; // React icons for edit/delete
import { FaExclamationTriangle } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Modal } from "react-bootstrap";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
function timeStringToMinutes(timeStr) {
  if (typeof timeStr === "number") {
    return timeStr;
  }
  const [h, m, s] = timeStr?.split(":").map(Number);
  return h * 60 + m + Math.floor(s / 60);
}
const RouteAddPage = () => {
  const navigate = useNavigate();
  const [routeDetails, setRoutedetails] = useState({
    name: "",
    route_number: "",
  });
  const [errors, setErrors] = useState({});
  const [stopSequence, setStopSequence] = useState([]);
  const [availableStops, setAvailableStops] = useState([]);
  const [newStop, setNewStop] = useState(null);
  const [orderNumber, setOrderNumber] = useState("");
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);
  const [showConfirm, setShowConfirm] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [buses, setBuses] = useState([]);
  const [timeDifference, setTimeDifference] = useState("");
  const [editTimeDifference, setEditTimeDifference] = useState("");
  const [selectedStopIndex, setSelectedStopIndex] = useState("");
  const [editStop, setEditStop] = useState(null);
  const [stopEditModal, setStopEditModal] = useState(false);
  const [removeDialog, setRemoveDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [stopType, setStopType] = useState("nextstop");
  const menuopen = Boolean(anchorEl);
  const handleEditModal = () => {
    handlemenuClose();
    setStopType("nextstop");
    setTimeout(() => {
      if (!stopEditModal) {
        const stopToEdit = stopSequence[selectedStopIndex];
        if (stopToEdit) {
          const selectedOption = availableStops.find(
            (opt) => opt.value == stopToEdit.stop
          );
          setEditStop(selectedOption || null);
          setEditTimeDifference(
            timeStringToMinutes(
              stopToEdit.travel_time_duration_from_prev_stop
            ) || ""
          );
          console.log(stopToEdit.travel_time_duration_from_prev_stop || "");
        }
      } else {
        setSelectedStopIndex("");
        setEditStop(null);
        setEditTimeDifference(null);
      }
      setStopEditModal(!stopEditModal);
    }, 150);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlemenuClose = () => {
    setAnchorEl(null);
  };
  const handleRemoveDialog = () => {
    handlemenuClose(); // 👈 close the menu manually
    setTimeout(() => {
      setRemoveDialog(!removeDialog);
    }, 150);
    console.log(removeDialog);
  };
  useEffect(() => {
    setNewStop(null);
    setTimeDifference("");
  }, [stopType]);
  useEffect(() => {
    async function fetchBusData() {
      try {
        const res = await getRouteStopListSearchApi();
        //    const stops = res?.data.map((d) =>
        //   d.label == "Plant Stop"
        //     ? { ...d, is_plant_stop: true }
        //     : { ...d, is_plant_stop: false }
        // );
        setAvailableStops(res?.data || []);
      } catch (err) {
        console.error("Error fetching stops", err);
      } finally {
        setIsLoading(false);
      }
    }
    fetchBusData();
  }, []);

  const validateStopAddInput = () => {
    let hasError = false;
    if (!newStop) {
      setErrors((prev) => ({
        ...prev,
        newStop: "Please select a stop to add.",
      }));
      hasError = true;
    }
    if (
      stopSequence.length !== 0 &&
      (timeDifference === "" || isNaN(timeDifference))
    ) {
      setErrors((prev) => ({
        ...prev,
        timeDifference: "Please enter a valid travel time duration.",
      }));
      hasError = true;
    }
    if (!hasError) {
      handleAddOrUpdateStop();
    }
  };
  const handleAddOrUpdateStop = () => {
    if (!newStop) return;

    const stopId = parseInt(newStop.value);
    const isPlantStop = newStop.is_plant_stop;

    if (!stopId) return;

    const existingIndex = stopSequence.findIndex((s) => s.stop === stopId);
    const updated = [...stopSequence];
    // Find index of first plant stop in the sequence
    const firstPlantIndex = stopSequence.findIndex((s) => {
      // You need access to `availableStops` to get `is_plant` of stop id
      const stopMeta = availableStops.find((x) => parseInt(x.value) === s.stop);
      return stopMeta?.is_plant_stop;
    });

    let insertIndex;

    if (orderNumber) {
      insertIndex = Math.min(
        Math.max(0, parseInt(orderNumber) - 1),
        stopSequence.length
      );
    } else if (firstPlantIndex !== -1) {
      insertIndex = firstPlantIndex;
    } else {
      insertIndex = stopSequence.length;
    }
    if (existingIndex >= 0) {
      const [existing] = updated.splice(existingIndex, 1);
      updated.splice(insertIndex, 0, existing);
    } else {
      const newEntry = {
        id: null,
        stop: stopId,
        travel_time_duration_from_prev_stop: timeDifference || 0,
      };
      updated.splice(insertIndex, 0, newEntry);
    }
    setStopSequence(updated.map((s, i) => ({ ...s, order: i + 1 })));
    setNewStop(null);
    setTimeDifference("");
    setOrderNumber("");
  };

  // const handleAddOrUpdateStop = () => {
  //   if (!newStop) return;
  //   const stopId = parseInt(newStop?.value);
  //   if (!stopId) return;

  //   const insertIndex = orderNumber
  //     ? Math.min(Math.max(0, parseInt(orderNumber) - 1), stopSequence.length)
  //     : stopSequence.length;

  //   const existingIndex = stopSequence.findIndex((s) => s.stop === stopId);

  //   const updated = [...stopSequence];

  //   if (existingIndex >= 0) {
  //     const [existing] = updated.splice(existingIndex, 1);
  //     updated.splice(insertIndex, 0, existing);
  //   } else {
  //     const newEntry = {
  //       id: null,
  //       stop: stopId,
  //       travel_time_duration_from_prev_stop: timeDifference || 0,
  //     };
  //     updated.splice(insertIndex, 0, newEntry);
  //   }

  //   setStopSequence(updated.map((s, i) => ({ ...s, order: i + 1 })));
  //   setNewStop(null);
  //   setTimeDifference("");
  //   setOrderNumber("");
  // };

  const handleRemove = () => {
    const updated = [...stopSequence];
    const currentStop = updated[selectedStopIndex];
    const nextStop = updated[selectedStopIndex + 1];
    if (nextStop) {
      const currentDuration = Number(
        currentStop?.travel_time_duration_from_prev_stop || 0
      );
      const nextDuration = Number(
        nextStop?.travel_time_duration_from_prev_stop || 0
      );

      nextStop.travel_time_duration_from_prev_stop =
        currentDuration + nextDuration;
    }
    updated.splice(selectedStopIndex, 1);
    const reordered = updated.map((stop, index) => ({
      ...stop,
      order: index + 1,
    }));

    setStopSequence(reordered);
    setSelectedStopIndex("");
    handleRemoveDialog();
  };

  const confirmDrop = () => {
    if (draggedIndex === null || dropIndex === null) return;
    const updated = [...stopSequence];
    const [moved] = updated.splice(draggedIndex, 1);
    updated.splice(dropIndex, 0, moved);
    setStopSequence(updated.map((s, i) => ({ ...s, order: i + 1 })));
    setDraggedIndex(null);
    setDropIndex(null);
    setShowConfirm(null);
  };

  const cancelConfirm = () => {
    setDraggedIndex(null);
    setDropIndex(null);
    setShowConfirm(null);
  };

  const handleDragStart = (index) => {
    const stop = stopSequence[index];
    const stopMeta = availableStops.find(
      (s) => parseInt(s.value) === stop.stop
    );
    if (stopMeta?.is_plant_stop) return; // Don't allow dragging a plant stop
    setDraggedIndex(index);
  };

  const handleDrop = (index) => {
    if (draggedIndex === null || draggedIndex === index) return;
    const targetStop = stopSequence[index];
    const stopMeta = availableStops.find(
      (s) => parseInt(s.value) === targetStop.stop
    );
    if (stopMeta?.is_plant_stop) return; // Don't allow dropping onto a plant stop
    setDropIndex(index);
    setShowConfirm(index);
    setConfirmAction(() => confirmDrop);
  };

  const goBack = () => navigate(`/routes`);

  const getAvailableStops = () => {
    const selectedIds = stopSequence.map((s) => s.stop.toString());

    if (stopType === "nextstop") {
      return availableStops.filter(
        (s) => !selectedIds.includes(s.value.toString()) && !s.is_plant_stop
      );
    }

    if (stopType === "endstop") {
      return availableStops.filter(
        (s) => !selectedIds.includes(s.value.toString()) && s.is_plant_stop
      );
    }

    return []; // fallback to empty list
  };

  const handlesubmit = () => {
    // Validate route details
    const newErrors = {};
    if (!routeDetails.name) {
      newErrors.name = "Route name is required.";
    }
    if (!routeDetails.route_number) {
      newErrors.route_number = "Route number is required.";
    }
    if (newStop !== null) {
      newErrors.newStop = "Please add the selected stop to the sequence.";
    }
    if (stopSequence.length < 2) {
      newErrors.newStop = "At least two stop is required.";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return; // Stop submission if there are errors
    }

    const payload = stopSequence.map((data) => ({
      stop_id: data.stop,
      order: data.order,
      travel_time_duration_from_prev_stop:
        data.travel_time_duration_from_prev_stop || 0,
    }));
    setIsSubmitLoading(true);
    createRouteApi({ ...routeDetails, stops: payload })
      .then((resp) => {
        toast.success(resp?.data?.message || "Stop sequence saved!");
        goBack();
      })
      .catch((err) => {
        console.log("error", err);
        toast.error(
          err?.response?.data?.message || "Error saving stop sequence."
        );
      })
      .finally(() => setIsSubmitLoading(false));
  };

  const getStop = (stopId) => {
    const stop = availableStops.find((s) => s.value === stopId);
    return stop;
  };
  const handleRouteDetailsChange = (e) => {
    const { name, value } = e.target;
    setRoutedetails({ ...routeDetails, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error for the field being changed
  };

  const getPrevStopName = (index) => {
    const prevStop = stopSequence[index];
    return getStop(prevStop.stop.toString())?.label || "Unknown Stop";
  };
  const getStopsForEdit = () => {
    if (selectedStopIndex === null) return getAvailableStops();

    const currentStopId = stopSequence[selectedStopIndex]?.stop;

    // Find current stop option (it won't be in availableStops)
    const currentStopOption = availableStops.find(
      (stop) => stop.value == currentStopId
    );
    console.log(currentStopId);
    console.log(currentStopOption);

    // Combine current stop with available stops (avoid duplicates)
    const combinedOptions = currentStopOption
      ? [
          currentStopOption,
          ...getAvailableStops().filter((opt) => opt.value !== currentStopId),
        ]
      : getAvailableStops();

    return combinedOptions;
  };
  const submitEditStop = () => {
    if (!editStop || selectedStopIndex === null) return;
    const stopId = parseInt(editStop.value);
    if (!stopId) return;

    let updated = [...stopSequence];
    updated[selectedStopIndex] = {
      ...updated[selectedStopIndex],
      stop: stopId,
      travel_time_duration_from_prev_stop: editTimeDifference || 0,
    };

    setStopSequence(updated.map((s, i) => ({ ...s, order: i + 1 })));
    setSelectedStopIndex("");
    setEditStop(null);
    setEditTimeDifference(null);
    handleEditModal();
  };
  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Add New Route</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/routes">Routes</Link>
                </li>
                <li className="breadcrumb-item active">Add Route</li>
              </ol>
            </nav>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card className="card-gutter-md">
          <Card.Body>
            <Row className="g-gs">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Route Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter Route Name"
                    value={routeDetails.name}
                    isInvalid={!!errors.name}
                    onChange={handleRouteDetailsChange}
                  />
                  {errors.name && (
                    <div className="text-danger">{errors.name}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Route Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="route_number"
                    isInvalid={!!errors.route_number}
                    placeholder="Enter Route Number"
                    value={routeDetails.route_number}
                    onChange={handleRouteDetailsChange}
                  />
                  {errors.route_number && (
                    <div className="text-danger">{errors.route_number}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <h4 className="bio-block-title my-4">
              {/* Route Shift & Buses */}
              Route Stops
            </h4>
            <ul className="">
              {stopSequence.map((item, index) => {
                const stopId = stopSequence[index].stop;
                const stopMeta = availableStops.find(
                  (s) => parseInt(s.value) === stopId
                );
                const isPlant = stopMeta?.is_plant_stop;

                return (
                  <li
                    key={index}
                    className={`${draggedIndex === index ? "dragging" : ""} ${
                      isPlant ? "no-drag" : ""
                    }`}
                    draggable={!isPlant}
                    onDragStart={() => !isPlant && handleDragStart(index)}
                    onDragOver={(e) => {
                      e.preventDefault();
                      if (isPlant) return;
                    }}
                    onDrop={() => {
                      if (!isPlant) handleDrop(index);
                    }}
                  >
                    <div
                      className="card mb-4 rounded-3 flex-fill"
                      // style={{ backgroundColor: "#f9fafb" }}
                    >
                      <div className="d-flex justify-content-between align-items-start px-2 py-3 w-100">
                        <div className="stop-data d-flex gap-2">
                          <span className="stop-pin">
                            <span className="stop-order">{index + 1}</span>
                          </span>
                          <span className="stop-name">
                            {getStop(item.stop.toString())?.label}{" "}
                            {item.travel_time_duration_from_prev_stop ? (
                              <span className="text-light">
                                (Travel Duration{" "}
                                {item.travel_time_duration_from_prev_stop}{" "}
                                minutes)
                              </span>
                            ) : null}
                          </span>
                        </div>
                        {showConfirm === index ? (
                          <div className="confirm-box mt-2">
                            <small>Are you sure to replace the Order?</small>
                            <div className="d-flex gap-2 mt-1">
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  if (
                                    draggedIndex !== null &&
                                    dropIndex !== null
                                  ) {
                                    // Drag-drop reorder
                                    const updated = [...stopSequence];
                                    const [moved] = updated.splice(
                                      draggedIndex,
                                      1
                                    );
                                    updated.splice(dropIndex, 0, moved);
                                    setStopSequence(
                                      updated.map((s, i) => ({
                                        ...s,
                                        order: i + 1,
                                      }))
                                    );
                                    setDraggedIndex(null);
                                    setDropIndex(null);
                                    setShowConfirm(null);
                                  } else {
                                    // Remove stop
                                    const updated = [...stopSequence];
                                    updated.splice(showConfirm, 1);
                                    setStopSequence(
                                      updated.map((s, i) => ({
                                        ...s,
                                        order: i + 1,
                                      }))
                                    );
                                    setShowConfirm(null);
                                  }
                                }}
                              >
                                Yes
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={cancelConfirm}
                              >
                                No
                              </button>
                            </div>
                          </div>
                        ) : (
                          <span className="action-icon d-flex justify-content-center align-items-center">
                            <BsThreeDotsVertical
                              onClick={(e) => {
                                setSelectedStopIndex(index);
                                handleClick(e);
                              }}
                            />
                          </span>

                          // <div
                          //   className="bg-light cursor-pointer"
                          //   style={{ padding: "0.2% 1%", borderRadius: "5px" }}
                          //   onClick={() => handleRemove(index)}
                          // >
                          //   <FaTrashCanArrowUp />
                          // </div>
                        )}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>

            {/* <div className="row align-items-center bg-light p-3 rounded">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Select New Stop</label>
                  <Select
                    onChange={(data) => {
                      setNewStop(data);
                      if (errors.newStop) {
                        setErrors((prev) => ({ ...prev, newStop: "" }));
                      }
                    }}
                    options={getAvailableStops()}
                    name="stop"
                    isClearable={true}
                    value={newStop}
                    placeholder="Select Stop"
                    className="react-select"
                    classNamePrefix="select"
                  />
                  {errors.newStop && (
                    <div className="text-danger">{errors.newStop}</div>
                  )}
                </div>
              </div>

              <div className="col-md-8 row p-0">
                <div className="col-md-8">
                  {stopSequence.length !== 0 && (
                    <div className="form-group ">
                      <label>
                        Travel Duration From Stop{" "}
                        <b>{getPrevStopName(stopSequence.length - 1)}</b>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={timeDifference}
                        onChange={(e) => {
                          const value = e.target.value;
                          const differenceInMinutes = parseInt(value, 10);
                          if (
                            !isNaN(differenceInMinutes) &&
                            differenceInMinutes >= 0
                          ) {
                            setTimeDifference(differenceInMinutes);
                          } else if (value === "") {
                            setTimeDifference("");
                          }
                          if (errors.timeDifference) {
                            setErrors((prev) => ({
                              ...prev,
                              timeDifference: "",
                            }));
                          }
                        }} // Pass stopId to the handler
                        placeholder="Enter Duration in Minutes"
                      />
                      {errors.timeDifference && (
                        <div className="text-danger">
                          {errors.timeDifference}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="col-md-4">
                  <div className="d-flex justify-content-md-end align-items-center h-100 justify-content-md-start">
                    <button
                      className="btn btn-secondary"
                      onClick={validateStopAddInput}
                      disabled={!getAvailableStops().length}
                    >
                      Add Stop
                    </button>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="mt-1 row bg-light shadow-sm rounded p-3 g-3 align-items-center">
              <div className="col-lg-5 col-md-12">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-center gap-3">
                  <div className="form-group mb-0">
                    <label className="form-label d-block">Stop Type</label>
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Stop Type"
                    >
                      <input
                        type="radio"
                        className="btn-check"
                        name="stopType"
                        id="nextStop"
                        value="nextstop"
                        checked={stopType === "nextstop"}
                        onChange={(e) => setStopType(e.target.value)}
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="nextStop"
                      >
                        Next
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="stopType"
                        id="endStop"
                        value="endstop"
                        checked={stopType === "endstop"}
                        onChange={(e) => setStopType(e.target.value)}
                      />
                      <label
                        className="btn  btn-outline-danger"
                        htmlFor="endStop"
                      >
                        End
                      </label>
                    </div>
                  </div>

                  {/* Select Stop */}
                  <div className="form-group flex-fill w-100">
                    <label className="form-label">Select Stop</label>
                    <Select
                      onChange={(data) => {
                        setNewStop(data);
                        if (errors.newStop) {
                          setErrors((prev) => ({ ...prev, newStop: "" }));
                        }
                      }}
                      options={getAvailableStops()}
                      name="stop"
                      isClearable={true}
                      value={newStop}
                      placeholder="Select Stop"
                      className={`react-select ${
                        errors.newStop ? "is-invalid" : ""
                      }`}
                      classNamePrefix="select"
                    />
                    {errors.newStop && (
                      <small className="text-danger">{errors.newStop}</small>
                    )}
                  </div>
                </div>
              </div>

              {/* Duration + Add Button */}
              <div className="col-lg-7 col-md-12">
                <div className="row g-3">
                  {/* Time Duration */}
                  <div className="col-md-8">
                    {stopSequence.length !== 0 && (
                      <div className="form-group">
                        <label className="form-label">
                          Duration from{" "}
                          <b>{getPrevStopName(stopSequence.length - 1)}</b>
                        </label>
                        <input
                          type="number"
                          className={`form-control ${
                            errors.timeDifference ? "is-invalid" : ""
                          }`}
                          value={timeDifference}
                          onChange={(e) => {
                            const value = e.target.value;
                            const differenceInMinutes = parseInt(value, 10);
                            if (
                              !isNaN(differenceInMinutes) &&
                              differenceInMinutes >= 0
                            ) {
                              setTimeDifference(differenceInMinutes);
                            } else if (value === "") {
                              setTimeDifference("");
                            }
                            if (errors.timeDifference) {
                              setErrors((prev) => ({
                                ...prev,
                                timeDifference: "",
                              }));
                            }
                          }}
                          placeholder="Enter Duration in Minutes"
                        />
                        {errors.timeDifference && (
                          <small className="text-danger">
                            {errors.timeDifference}
                          </small>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Add Stop Button */}
                  <div className="col-md-4 d-flex align-items-end align-item-md-center">
                    <button
                      className="btn btn-success w-100"
                      onClick={validateStopAddInput}
                      disabled={!getAvailableStops().length}
                    >
                      Add Stop
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
            <div className="d-flex align-items-center justify-content-center gap-2">
              <button
                className="btn btn-outline-secondary"
                onClick={goBack}
                disabled={isSubmitLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handlesubmit}
                disabled={isSubmitLoading}
              >
                {isSubmitLoading ? "Saving..." : "Save"} Stop Sequence
              </button>
            </div>
          </Card.Footer>
        </Card>
      </Block>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={menuopen}
        onClose={handlemenuClose}
        onClick={handlemenuClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              minWidth: 160,
              borderRadius: 2,
              "& .MuiMenuItem-root": {
                px: 2,
                py: 1,
                fontSize: "0.95rem",
                gap: 1.5,
              },
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleEditModal}>
          <ListItemIcon>
            <MdEdit size={20} className="text-primary" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleRemoveDialog}>
          <ListItemIcon>
            <MdDelete size={20} className="text-danger" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
      <Dialog open={removeDialog} onClose={handleRemoveDialog}>
        <DialogTitle className="d-flex align-items-center gap-3 text-danger fs-5">
          <div
            className="d-flex justify-content-center align-items-center bg-warning bg-opacity-25 rounded-circle"
            style={{ width: 40, height: 40 }}
          >
            <FaExclamationTriangle size={20} className="text-warning" />
          </div>
          <span>Confirm Stop Removal</span>
        </DialogTitle>

        <DialogContent>
          <div
            className="p-3 rounded shadow-sm bg-light border-start border-4 border-warning"
            style={{ fontSize: "0.95rem" }}
          >
            <strong className="text-dark d-block mb-2">Are you sure?</strong>
            <p className="mb-0 text-secondary">
              This action is <u>permanent</u> and{" "}
              <strong>cannot be undo</strong>. Please confirm to proceed with
              stop removal.
            </p>
          </div>
        </DialogContent>

        <DialogActions className="px-3 pb-3">
          <button
            className="btn btn-outline-secondary"
            onClick={handleRemoveDialog}
          >
            Cancel
          </button>
          <button className="btn btn-danger" onClick={handleRemove}>
            Remove Stop
          </button>
        </DialogActions>
      </Dialog>
      <Modal show={stopEditModal} onHide={handleEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Stop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-2">
            {
              !(availableStops?.find((data)=>data.value==stopSequence?.find((_,i)=>i==selectedStopIndex)?.stop)?.is_plant_stop)&&(
                 <div>
                <label className="form-label">Selecte Stop</label>
                <Select
                  options={getStopsForEdit()}
                  value={editStop}
                  onChange={(data) => {
                    setEditStop(data);
                  }}
                  isClearable={true}
                  name="stop"
                  placeholder="Select Stop"
                  className="react-select"
                  classNamePrefix="select"
                />
              </div>
              )
            }
           
            {selectedStopIndex != 0 && (
              <div className="mt-2">
                Duration from <b>{getPrevStopName(selectedStopIndex - 1)}</b>
                <input
                  type="number"
                  className="form-control"
                  value={editTimeDifference}
                  onChange={(e) => {
                    const value = e.target.value;
                    const differenceInMinutes = parseInt(value, 10);
                    console.log(differenceInMinutes);
                    if (
                      !isNaN(differenceInMinutes) &&
                      differenceInMinutes >= 0
                    ) {
                      setEditTimeDifference(differenceInMinutes);
                    } else if (value === "") {
                      setEditTimeDifference("");
                    }
                  }} // Pass stopId to the handler
                  placeholder="Enter Duration in Minutes"
                />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-100 justify-content-center aligin-items-center gap-1">
            <button
              className="btn btn-outline-secondary"
              onClick={handleEditModal}
              // disabled={createtriploading}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={submitEditStop}
              disabled={
                !editStop || (selectedStopIndex !== 0 && !editTimeDifference)
              }
            >
              {/* {createtriploading && <Spinner animation="border" size="sm" />} */}
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RouteAddPage;
